import articlePt from "../assets/articles/TCC.pdf"
import ptcv from "../assets/cv/BeatrizNeaime_CV[PT].pdf"
import encv from "../assets/cv/BeatrizNeaime_CV[EN].pdf"

export const texts = {
  pt: {
    cv: {
      title: "Currículo - Beatriz Neaime",
      btn: "Currículo",
      cv: ptcv
    },
    landing: {
      subtitle: "Desenvolvedora Full Stack.",
      contact: "Fale Comigo",
      talk: "Vamos conversar.",
    },
    navbar: {
      home: "Início",
      about: "Sobre",
      skills: "Habilidades",
      projects: "Projetos",
      contact: "Contato",
    },
    about: {
      title: "<sobre/>",
      text: "Olá! Meu nome é Beatriz. Sou Engenheira de Computação, com pós-graduação em Engenharia de Software. Atualmente, trabalho como Desenvolvedora Full Stack Pleno na",
      empresa: " Sistema ESO",
      link: "https://sistemaeso.com.br",
      text2: ", onde tenho a oportunidade de criar e aprimorar soluções tecnológicas completas, desde a interface do usuário até a infraestrutura de servidores. Comecei a aprender desenvolvimento web durante a pandemia, através de cursos online para aprender o básico e aprimorar minhas habilidades, garantindo que aprendi o suficiente para seguir em frente e tentar as tecnologias mais recentes. Estou sempre em busca de novos desafios e oportunidades para aplicar e expandir meu conhecimento. Aqui estão algumas tecnologias com as quais estou familiarizada:",
      text3: "Quer saber mais sobre minha jornada? Você pode baixar meu currículo clicando no botão abaixo.",
      article: articlePt
    },
    skills: {
      title: "<habilidades/>",
      text: "Desde o início da minha jornada como desenvolvedora, aprimorei minhas soft skills, sempre buscando ser uma profissional melhor.",
      1: {
        title: "aprendizado contínuo",
        text: "A tecnologia nunca para de se atualizar, é por isto que aqueles que trabalham com tecnologia não devem parar de se atualizar também.",
      },
      2: {
        title: "comunicativa",
        text: "Não importa sua profissão, comunicação é sempre uma necessidade em qualquer ramo.",
      },
      3: {
        title: "mente aberta",
        text: "Quando se trabalha para pessoas, é necessário aceitar novas ideias de clientes ou colegas de equipe e ser capaz de trabalhar nelas.",

      }
    },
    projects: {
      title: "<projetos/>",
      text: "Projetos são maneiras importantes de melhorar suas habilidades e mostrar o que você é capaz de fazer. Aqui estão alguns dos meus projetos mais recentes. Você pode clicar na imagem para saber mais.",
    },
    contact: {
      title: "<contato/>",
      text: "Sinta-se a vontade para me enviar uma mensagem!.",
      btn: "Envie uma mensagem"
    }
  },
  en: {
    cv: {
      title: "Beatriz Neaime's CV",
      btn: "CV",
      cv: encv
    },
    landing: {
      subtitle: "Full Stack Developer.",
      contact: "Contact Me",
      talk: "Let's talk.",
    },
    navbar: {
      home: "Home",
      about: "About",
      skills: "Skills",
      projects: "Projects",
      contact: "Contact",
    },
    about: {
      title: "<about/>",
      text: "Hello! My name is Beatriz. I am a Computer Engineer, with a postgraduate degree in Software Engineering. I currently work as a Mid-Level Full Stack Developer at",
      empresa: " Sistema ESO",
      link: "https://sistemaeso.com.br",
      text2: ", where I have the opportunity to create and enhance complete technological solutions, from user interfaces to server infrastructure. I started learning web development during the pandemic, through online courses to learn the basics and enhance my skills, ensuring I learned enough to move forward and try the latest technologies. I am always looking for new challenges and opportunities to apply and expand my knowledge. Here are some technologies I am familiar with:",
      text3: "Want to know more about my journey? You can download my CV by clicking the button below.",
      article: articlePt
    },
    skills: {
      title: "<skills/>",
      text: `Since the beginning of my journey as a developer, I've improved my soft skills, always seeking to be a better professional. `,
      1: {
        title: "non-stop learning",
        text: "Technology never stops updating, that's why those who work with technology should not stop updating themselves either.",
      },
      2: {
        title: "communicative",
        text: "No matter your profession, communication is always a need in any field.",
      },
      3: {
        title: "open-minded",
        text: "When you work for people, you need to accept new ideas from clients or team members and be able to work on them.",

      }
    },
    projects: {
      title: "<projects/>",
      text: "Projects are important ways to improve your skills and show what you are capable of. Here are some of my most recent projects. You can click on the image to find out more. ",
    },
    contact: {
      title: "<contact/>",
      text: "Feel free to send me a message!.",
      btn: "Send a message"
    }
  }
}